import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { setIsOpen } from '../competencyDrawerSlice';
import { TagInfo } from '../types/tagInfo';

interface SetCompetencyQueryParamsArgs extends Pick<TagInfo, 'tagId' | 'employeeId'> {
  history: ReturnType<typeof useHistory>;
  location: ReturnType<typeof useLocation>;
}

const setCompetencyQueryParams = ({ history, location, tagId, employeeId }: SetCompetencyQueryParamsArgs) => {
  const queryParams = new URLSearchParams(location.search);
  if (tagId) {
    queryParams.set('competencyId', tagId);
  }
  queryParams.set('empId', employeeId);
  queryParams.set('isCompetencyPanelOpen', 'true');
  history.replace({ search: queryParams.toString() });
};

const removeCompetencyQueryParams = ({
  history,
  location,
}: Pick<SetCompetencyQueryParamsArgs, 'history' | 'location'>) => {
  const queryParams = new URLSearchParams(location.search);
  queryParams.delete('competencyId');
  queryParams.delete('empId');
  queryParams.delete('isCompetencyPanelOpen');
  queryParams.delete('scrollToId');
  queryParams.delete('isSharePublicPraise');
  history.replace({ search: queryParams.toString() });
};

export const useOpenCompetencyDrawer = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const openCompetencyPanel = ({
    tagTitle,
    tagDescription,
    tagId,
    employeeId,
    onClose,
    hideShareFeedbackButtons,
  }: TagInfo) => {
    setCompetencyQueryParams({ history, location, tagId, employeeId });
    dispatch(setIsOpen(true));
  };

  const closeCompetencyPanel = () => {
    removeCompetencyQueryParams({ history, location });
    dispatch(setIsOpen(false));
  };

  return { openCompetencyPanel, closeCompetencyPanel };
};
